function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12 3c6.627 0 12 5.371 12 11.997 0 2.025-.503 3.976-1.45 5.718-.081.15-.228.253-.395.279l-.084.006-11.427-.003H8.138L1.928 21c-.201 0-.385-.11-.48-.285C.501 18.975 0 17.02 0 14.997 0 8.37 5.373 3 12 3zm0 1.09c-6.025 0-10.91 4.884-10.91 10.907 0 1.578.336 3.108.973 4.508l.165.348.028.056 11.342-.003h2.482l5.662.003.028-.057c.675-1.353 1.061-2.834 1.129-4.371l.01-.385v-.1C22.91 8.975 18.025 4.092 12 4.092zm-1.505 9.512c.252-.14 3.687-1.748 3.905-1.53.29.29-1.423 3.764-1.618 4.045-.315.456-.84.754-1.437.754-.964 0-1.745-.78-1.745-1.745 0-.655.361-1.226.895-1.524zM12 7.472c3.856 0 6.982 3.125 6.982 6.98 0 .3-.244.545-.546.545-.3 0-.545-.244-.545-.545 0-3.253-2.638-5.89-5.891-5.89s-5.89 2.637-5.89 5.89c0 .3-.245.545-.546.545-.302 0-.546-.244-.546-.545 0-3.855 3.126-6.98 6.982-6.98z",
  transform: "translate(-301 -608) translate(0 559) translate(301 49)"
})))));

var SvgIconDashboardWhite = function SvgIconDashboardWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDashboardWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dashboard-white.66bce5d2.svg";
export { ForwardRef as ReactComponent };